import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createRecipe } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import type { Recipe } from "../types";

export function useCreateRecipe() {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (data: Partial<Recipe>) => {
      const token = await getToken();
      if (!token) throw new Error("Not authenticated");
      return createRecipe(data, token);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["recipes"] });
    },
  });
}
